import type React from 'react';

function KlintIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1545 1545"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Klint Icon</title>

      <g id="Layer_1-2" data-name="Layer 1">
        <rect width="1545" height="1545" fill="none" />

        <g id="Layer_1-2" data-name="Layer 1-2">
          <g>
            <path d="M570.84,1521.53H205.17v-37.57c0-351.08-.38-702.17,.64-1053.25,.13-33.81-6.56-61.51-30.18-86.21-15.98-16.68-28.65-36.55-44.89-57.69C277.18,199.21,422.29,112.36,570.84,23.47V1521.53Z" />
            <path d="M1395,1522.62h-208.33c-64.63,0-129.32,.64-193.94-.64-11.02-.19-25.47-5.67-32.15-13.75-37.69-45.78-73.54-93.15-109.96-140.01-65.58-84.49-131.16-169.05-197.25-254.3,55.46-109.2,110.53-217.69,167.33-329.56,191.65,246.34,381.14,489.95,574.32,738.27h0Z" />
            <path d="M864.81,687.82c47.82-81.69,90.99-166.63,144.79-244.18,55.9-80.61,149.88-103.21,226.8-66.47,78.63,37.57,112.44,128.17,79.53,213.24-32.22,83.28-117.28,125.37-201.01,98.75-20.12-6.43-39.35-15.54-58.96-23.56-73.48-30.12-121.36-22.99-182.23,27.38l-8.91-5.09v-.06Z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default KlintIcon;
